import { createSlice } from '@reduxjs/toolkit'
import {
  createCustomer,
  fetchCustomers,
  fetchSingleCustomer,
  blockCustomer,
  deactivateCustomer,
} from '../actions/customerActions.js'

const initialState = {
  customers: [],
  singleCustomer: null,
  loading: false,
  error: null,
}

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    resetCustomerState: state => {
      state.customers = []
      state.loading = false
      state.error = null
    },
    getCustomerRequest: state => {
      state.loading = true
      state.error = null
    },
    getCustomerSuccess: (state, action) => {
      state.loading = false
      state.singleCustomer = action.payload
    },
    getCustomerFail: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchCustomers.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.customers = action.payload.data
        state.loading = false
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.error = action.payload
        state.loading = false
      })
      .addCase(fetchSingleCustomer.pending, state => {
        state.loading = true
        state.singleCustomer = null
        state.error = null
      })
      .addCase(fetchSingleCustomer.fulfilled, (state, action) => {
        state.singleCustomer = action.payload.data // Store single property separately
        state.loading = false
      })
      .addCase(fetchSingleCustomer.rejected, (state, action) => {
        state.error = action.payload
        state.loading = false
      })
      .addCase(createCustomer.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.customers.push(action.payload)
        state.loading = false
      })
      .addCase(createCustomer.rejected, (state, action) => {
        state.error = action.error.message
        state.loading = false
      })
      .addCase(blockCustomer.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(blockCustomer.fulfilled, (state, action) => {
        const index = state.customers.findIndex(customer => customer.id === action.payload.id)
        state.customers[index] = action.payload
        state.loading = false
      })
      .addCase(deactivateCustomer.rejected, (state, action) => {
        state.error = action.error.message
        state.loading = false
      })
      .addCase(deactivateCustomer.fulfilled, (state, action) => {
        state.customers = state.customers.filter(customer => customer.id !== action.payload.id)
        state.loading = false
      })
  },
})

export const { resetCustomerState, getCustomerRequest, getCustomerSuccess, getCustomerFail } = customerSlice.actions

export default customerSlice.reducer
